import './index.scss';

import { Component, DetailedHTMLProps, HTMLAttributes, Ref } from 'react';

import { BraxThemeVariant } from '../../types';

export type BraxDashedBorderProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    innerRef?: Ref<HTMLDivElement>
    width: string | number,
    dashArray: string | number,
    dashOffset: string | number,
    className?: string,
    variant: BraxThemeVariant
};

export class BraxDashedBorder extends Component<BraxDashedBorderProps> {

    static defaultProps = {
        width: 2,
        dashArray: '15, 15',
        dashOffset: 0,
        variant: 'text'
    };

    render() {
        const { innerRef, className, variant, width, dashArray, children, dashOffset, ...props } = this.props;

        return (
            <div ref={innerRef} className={`brax-dashed-border ${variant} ${className || ''}`} {...props}>
                { children }

                <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                    <rect width="100%" height="100%" fill="none" strokeWidth={width} strokeDasharray={dashArray} strokeDashoffset={dashOffset} strokeLinecap="square" rx="4px" ry="4px" />
                </svg>
            </div>
        );
    }

}
